import React, { useState, useEffect } from "react";
import "./Calender.css";
import axios from "axios";
import appConfig from '../config/appConfig.json';

const Calendar = () => {
  const currentDate = new Date();
  const [selectedDate, setSelectedDate] = useState({
    day: currentDate.getDate(),
    month: currentDate.getMonth(),
    year: currentDate.getFullYear()
  });
  const [panchangData, setPanchangData] = useState({});
  const [loading, setLoading] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);

  const formatDateKey = (day, month, year) => {
    return `${year}-${(month + 1).toString().padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
  };

  const fetchPanchangData = async (day, month, year) => {
    const dateKey = formatDateKey(day, month, year);
    
    if (panchangData[dateKey]) return;

    setLoading(true);
    try {
      const response = await axios.post(
        `${appConfig.REACT_APP_BACKEND_URL}/panchang/panchang`,
        { 
          year, 
          month, 
          day,
          specificDate: dateKey
        }
      );

      const newData = Array.isArray(response.data) ? response.data[0] : response.data;
      
      if (newData) {
        setPanchangData(prev => ({
          ...prev,
          [dateKey]: newData
        }));
      }
    } catch (error) {
      console.error("Error fetching Panchang data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPanchangData(selectedDate.day, selectedDate.month, selectedDate.year);
  }, [selectedDate]);

  const handleDateChange = (e) => {
    const newDate = new Date(e.target.value);
    setSelectedDate({
      day: newDate.getDate(),
      month: newDate.getMonth(),
      year: newDate.getFullYear()
    });
    setShowDatePicker(false);
  };

  const renderDateCard = () => {
    const dateKey = formatDateKey(selectedDate.day, selectedDate.month, selectedDate.year);
    const details = panchangData[dateKey];
    const date = new Date(selectedDate.year, selectedDate.month, selectedDate.day);
    const weekday = date.toLocaleDateString("en-US", { weekday: "long" });
    const monthName = date.toLocaleDateString("en-US", { month: "long" });

    const isToday = 
      selectedDate.day === currentDate.getDate() &&
      selectedDate.month === currentDate.getMonth() &&
      selectedDate.year === currentDate.getFullYear();

    return (
      <div className="panchang-card">
        <div className="card-header">
          <h2>
            {weekday}, {monthName} {selectedDate.day}, {selectedDate.year}
            {isToday && <span className="today-badge">Today</span>}
          </h2>
          <button 
            className="calendar-button"
            onClick={() => setShowDatePicker(!showDatePicker)}
            aria-label="Select date"
          >
            <span role="img" aria-hidden="true">📅</span>
          </button>
        </div>

        {showDatePicker && (
          <div className="date-picker-popup">
            <input 
              type="date" 
              onChange={handleDateChange}
              value={`${selectedDate.year}-${(selectedDate.month + 1).toString().padStart(2, '0')}-${selectedDate.day.toString().padStart(2, '0')}`}
              onBlur={() => setShowDatePicker(false)}
              autoFocus
            />
          </div>
        )}

        <div className="card-body">
          {loading ? (
            <div className="loading">Loading Panchang data...</div>
          ) : details ? (
            <>
              <div className="panchang-grid">
                <div className="panchang-item">
                  <div className="panchang-icon">📅</div>
                  <div>
                    <div className="panchang-label">Tithi</div>
                    <div className="panchang-value">{details.tithi}</div>
                  </div>
                </div>
                
                <div className="panchang-item">
                  <div className="panchang-icon">⭐</div>
                  <div>
                    <div className="panchang-label">Nakshatra</div>
                    <div className="panchang-value">{details.nakshatra}</div>
                  </div>
                </div>
                
                <div className="panchang-item">
                  <div className="panchang-icon">🌅</div>
                  <div>
                    <div className="panchang-label">Sunrise</div>
                    <div className="panchang-value">{details.sunrise}</div>
                  </div>
                </div>
                
                <div className="panchang-item">
                  <div className="panchang-icon">🌇</div>
                  <div>
                    <div className="panchang-label">Sunset</div>
                    <div className="panchang-value">{details.sunset}</div>
                  </div>
                </div>
              </div>

              {details.events?.length > 0 && (
                <div className="events-section">
                  <h3>Today's Events</h3>
                  <ul className="events-list">
                    {details.events.map((event, i) => (
                      <li key={i}>{event}</li>
                    ))}
                  </ul>
                </div>
              )}
            </>
          ) : (
            <div className="no-data">No Panchang data available</div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="panchang-container">
      {renderDateCard()}
    </div>
  );
};

export default Calendar;